var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['underscore', 'underscore.string', 'core', 'app-common/component/service-call'], function(_, _s, core, serviceCall) {
  var Categorizer;
  return Categorizer = (function() {

    function Categorizer(clientId) {
      this.clientId = parseInt(clientId, 10);
      this.collection = core.getCollection('categorizerRules');
      this.collection.fetch();
    }

    Categorizer.prototype.categorize = function(transactions, sourceLedgerAccountId) {
      var data, transactionsData,
        _this = this;
      transactionsData = _.map(transactions, function(row) {
        return {
          id: row.id,
          vendor: row.vendorName,
          amount: row.amount
        };
      });
      data = {
        transactions: transactionsData,
        clientId: this.clientId,
        sourceLedgerAccountId: parseInt(sourceLedgerAccountId)
      };
      return serviceCall('categorizer', 'cloudmlcategorize', 'POST', data).then(function(matchedTransactions) {
        var matchedRules;
        matchedRules = matchedTransactions.map(function(transaction) {
          return transaction.matchedRule || transaction.matchedGlobalRule;
        }).filter(function(rule) {
          return !!rule;
        });
        transactions = _.map(_.zip(transactions, matchedTransactions), function(_arg) {
          var matchedTransaction, transaction;
          transaction = _arg[0], matchedTransaction = _arg[1];
          if (_this.isPendingCategoryId(transaction) && (transaction.reconciliationState !== 'CONFLICT')) {
            return _this.matchTransaction(transaction, matchedTransaction);
          } else {
            return transaction;
          }
        });
        return [transactions, matchedRules];
      });
    };

    Categorizer.prototype.getDefaultLedgerId = function(matchedLedger) {
      var _ref;
      if (!matchedLedger) {
        return;
      }
      return (matchedLedger != null ? matchedLedger.ledgerId : void 0) || ((_ref = core.getCollection('ledgerAccounts').findWhere({
        code: matchedLedger.ledgerCode
      })) != null ? _ref.id : void 0);
    };

    Categorizer.prototype.getReconciliationStateMessage = function(clientRule, globalRule, matchedLedger, suggestedLedgers) {
      var matchText, maxAmountText, minAmountText, rule, ruleText;
      rule = clientRule || globalRule || {};
      minAmountText = rule.minAmount ? ", Min: $" + rule.minAmount : '';
      maxAmountText = rule.maxAmount ? ", Max: $" + rule.maxAmount : '';
      matchText = (function() {
        switch (false) {
          case globalRule == null:
            return 'Global rule: ';
          case !clientRule:
            return 'Client rule: ';
          case (matchedLedger != null ? matchedLedger.confidence : void 0) == null:
            return 'ML prediction';
          case !((suggestedLedgers != null ? suggestedLedgers.length : void 0) > 0):
            return 'ML suggestion';
          default:
            return '';
        }
      })();
      ruleText = rule.vendorContains || '';
      return matchText + ruleText + minAmountText + maxAmountText;
    };

    Categorizer.prototype.getCategorizationMeta = function(matchedTransaction) {
      var clientRule, globalRule, matchedLedger, suggestedLedgers;
      clientRule = matchedTransaction.matchedRule;
      globalRule = matchedTransaction.matchedGlobalRule;
      matchedLedger = matchedTransaction.matchedLedger;
      suggestedLedgers = matchedTransaction.suggestedLedgers;
      return {
        reconciliationState: 'MATCHED_RULE',
        reconciliationStateMessage: this.getReconciliationStateMessage(clientRule, globalRule, matchedLedger, suggestedLedgers),
        categorizationRuleId: clientRule != null ? clientRule.id : ''
      };
    };

    Categorizer.prototype.getCategorizerMethod = function(matchedTransaction) {
      var clientRule, globalRule, matchedLedger, _ref;
      clientRule = matchedTransaction.matchedRule;
      globalRule = matchedTransaction.matchedGlobalRule;
      matchedLedger = matchedTransaction.matchedLedger;
      switch (false) {
        case globalRule == null:
          return 'GLOBAL_RULE';
        case !clientRule:
          return 'CLIENT_RULE';
        case !(((matchedLedger != null ? matchedLedger.confidence : void 0) != null) || ((_ref = matchedTransaction.suggestedLedgers) != null ? _ref.length : void 0) > 0):
          return 'ML';
        default:
          return null;
      }
    };

    Categorizer.prototype.matchTransaction = function(transaction, matchedTransaction) {
      var categorizerRule, defaultLedgerId, matchedLedger, suggestedLedgers,
        _this = this;
      matchedLedger = matchedTransaction.matchedLedger;
      defaultLedgerId = this.getDefaultLedgerId(matchedLedger);
      categorizerRule = matchedTransaction.matchedRule || matchedTransaction.matchedGlobalRule || null;
      suggestedLedgers = matchedTransaction.suggestedLedgers.map(function(suggestedLedger) {
        return {
          ledgerAccountId: _this.getDefaultLedgerId(suggestedLedger)
        };
      }).filter(function(suggestedLedger) {
        return !!suggestedLedger.ledgerAccountId;
      });
      if (defaultLedgerId != null) {
        return Object.assign({}, transaction, this.getCategorizationMeta(matchedTransaction), {
          defaultLedgerId: defaultLedgerId,
          suggestedLedgers: suggestedLedgers,
          categorizerRule: categorizerRule,
          categorizerUuid: matchedTransaction.uuid,
          categorizerLedgerId: defaultLedgerId,
          categorizerMethod: this.getCategorizerMethod(matchedTransaction)
        });
      } else if (suggestedLedgers.length > 0) {
        return Object.assign({}, transaction, this.getCategorizationMeta(matchedTransaction), {
          suggestedLedgers: suggestedLedgers,
          categorizerUuid: matchedTransaction.uuid,
          categorizerMethod: this.getCategorizerMethod(matchedTransaction)
        });
      } else {
        return Object.assign({}, transaction, {
          categorizerUuid: matchedTransaction.uuid
        });
      }
    };

    Categorizer.prototype.isPendingCategoryId = function(transaction) {
      var ids, ledgers, _ref;
      ledgers = core.getDefaultLedgers();
      ids = [ledgers['pending.category.revenue'].id, ledgers['pending.category.expense'].id];
      return _ref = transaction.defaultLedgerId, __indexOf.call(ids, _ref) >= 0;
    };

    Categorizer.prototype.getLedgerRules = function(ledgerId) {
      return this.collection.where({
        ledgerId: parseInt(ledgerId)
      });
    };

    return Categorizer;

  })();
});
